'use client';

import CommentTextarea from '@/app/[locale]/(worlds)/[roomId]/components/CommentTextarea';
import ViverseAvatar from '@/components/ViverseAvatar';
import { COMMENT_MAXIMUM_CHARACTERS } from '@/constants/comment';
import { useConfigsContext } from '@/context/ConfigsContext';
import { useState } from 'react';
function CommentBlockTextarea({
  textAreaElementId,
  addComment
}: {
  textAreaElementId: string;
  addComment: (value: string) => Promise<void>;
}) {
  const [value, setValue] = useState('');
  const {
    store
  } = useConfigsContext();
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };
  const handleAdd = async () => {
    const trimmedValue = value.trim();
    if (!trimmedValue) return;
    setIsLoading(true);
    try {
      await addComment(trimmedValue);
      setValue('');
    } catch (error) {
      console.error('Error adding comment:', error);
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="flex min-h-8.5 justify-between gap-2 md:gap-4">
      <ViverseAvatar size="S" imageUrl={store?.profile?.avatarSnapshot} name={store?.profile?.displayName} />
      <CommentTextarea textAreaElementId={`reply-comment-${textAreaElementId}`} value={value} submitButtonSize="S" onChange={handleChange} onSubmit={handleAdd} disabled={isLoading} maxLength={COMMENT_MAXIMUM_CHARACTERS} />
    </div>;
}
export default CommentBlockTextarea;